<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { setCookie, getCookie } from './assets/common/js/config'
import { customRequestAjax } from '@/axiosApi'
export default {
  name: 'App'
}
</script>

<style>
/*引入PingFang.css文件*/
@import '../src/assets/font/PingFang.css';
/*引入common.css文件*/
@import '../src/assets/common/css/common.css';
@import '../src/assets/font/MSGothic.css';
</style>
<style lang="less">
  /*引入公共弹出框样式*/
  /*@import 'assets/common/css/popUp.scss';*/
</style>



// WEBPACK FOOTER //
// src/App.vue